/**
 * Return Brand name.
 * @param  {String} brand The current brand code
 */
export function getMetaBrand (brand) {
  switch (brand) {
    case 'wp':
      return 'Whirlpool'
    case 'id':
      return 'Indesit'
    case 'hp':
      return 'Hotpoint'
    case 'bk':
      return 'Bauknecht'
    case 'mb':
      return 'Indesit'
    default:
      return ''
  }
}

/**
 * Return Country name (static string by Lang_Country[Brand] set in i18n locale files).
 * @param  {String} brand The current brand code
 * @param  {Object} i18n The list of locale static translations by i18n/Lang_Country
 */
export function getMetaCountry (brand, i18n) {
  var label = `wia_seo_${brand}_country_name`
  if (Object.keys(i18n).length > 0 && i18n[label]) {
    return i18n[label]
  } else {
    return ''
  }
}

/**
 * Return Meta Title/Description (static string by Lang_Country[Brand] set in i18n locale files).
 * @param  {String} tag Tag name to retrieve
 * @param  {String} brand The current brand code
 * @param  {Object} i18n The list of locale static translations by i18n/Lang_Country
 */
export function getMetaStaticByTag (tag, brand, i18n) {
  var label = `wia_seo_${brand}_meta_${tag}`
  if (Object.keys(i18n).length > 0 && i18n[label]) {
    return i18n[label]
  } else {
    return ''
  }
}
